import * as React from 'react';
import ApiTable from "../Components/Table/ApiTable";
import { useState, useEffect } from 'react';
import ApiService from "../Services/ApiService";
import { PROJECTSHEADER } from "../Utils/constants/tableHeaders";
import ProjectsFilter from "../Components/FilterSections/ProjectsFilter";
import ProjectsAlter from '../Components/AlterSections/ProjectsAlter';
import ProjectIcon from '../Components/PageIcons/ProjectIcon';
import { navbarIconSx } from '../Utils/styles/sxStyles';
import { transformProjectData } from '../Utils/helpers/apiTransformation';
import { ENDPOINT_PROJECTS } from '../Utils/constants/apiEndpointCodes';
import { TITLE_PLURAL_PROJECT } from '../Utils/constants/titleCodes';
import { useStore } from '../Services/StoreService';
import PageWrapper from '../Components/PageWrapper';

const ProjectsPage = () => {

    const [rows, setRows] = useState([]);
    const [dataView, setDataView] = useState([]);
    const [hasData, setHasData] = useState(false);
    const [globalState, dispatch] = useStore();

    useEffect(() => {
        if (globalState.isSuccess || !hasData) {
            ApiService.apiGetRequest(ENDPOINT_PROJECTS, (res) => transformProjectData(res, setRows));
            setDataView(rows);
            setHasData(true);
            dispatch('SUCCESSFUL_REQUEST', false);
        }
    }, [hasData, rows, globalState]);

    return (
        <PageWrapper
            title={TITLE_PLURAL_PROJECT}
            icon={<ProjectIcon sx={navbarIconSx} />}
        >
            <ProjectsAlter
                rows={rows}
            />
            <ProjectsFilter
                rows={rows}
                setDataView={setDataView}
                setHasData={setHasData}
            />
            <ApiTable
                headCells={PROJECTSHEADER}
                rows={dataView}
                setRows={setRows}
            />
        </PageWrapper>

    )
}

export default ProjectsPage;